export var SubscriptionTransactionType;
(function (SubscriptionTransactionType) {
    SubscriptionTransactionType["Payment"] = "Payment";
    SubscriptionTransactionType["Refund"] = "Refund";
    SubscriptionTransactionType["Chargeback"] = "Chargeback";
    SubscriptionTransactionType["Credit"] = "Credit";
    SubscriptionTransactionType["Upgrade"] = "Upgrade";
    SubscriptionTransactionType["Downgrade"] = "Downgrade";
})(SubscriptionTransactionType || (SubscriptionTransactionType = {}));
//# sourceMappingURL=subscription-transaction-type.const.js.map